import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import {
  BackArrowWrapper,
  BackHomeLabel,
  GoBackWrapper,
  HeaderWrapper,
  LogoWrapper,
  SelectedDeliveryOptionText,
  StartOverContainer,
  StartOverIconWrapper,
  StartOverLabelText,
  ToggleButtonContainer,
  ToggleButtonLabelText,
  ToggleButtonWrapper,
} from "./style";
import Image from "../../components/atoms/image";

import FSTRLogo from "../../assets/logo/headerLogo.png";
import { ArrowLeft, Setting, Signout, StartOver } from "../../utils/iconList";
import Button from "../../components/atoms/button";
import Text from "../../components/atoms/text";
import GateSelectionModal from "../gateSelectionModal/gateSelectionModal";
import { UserContext } from "../../context/userContext";
import { DeliveryOptionContext } from "../../context/deliveryOptionContext";
import { CartContext } from "../../context/cartContext";
import { FoodTypeContext } from "../../context/foodTypeContext";
import config from "../../config/config";
import moment from "moment";
import styles from "./style.module.css";
import { showDeliveryOption } from "../../utils/helperFunctions";
import { hideDelSelectionPostStart } from "../../config/envConfig";
import { getLocalStorage, removeLocalStorage } from "../../utils/storageUtil";

function Header(props) {
  const useUser = useContext(UserContext);
  const useDelivery = useContext(DeliveryOptionContext);
  const useCart = useContext(CartContext);
  const useFoodType = useContext(FoodTypeContext);
  const history = useHistory();
  const [delOpt, setDelOpt] = useState(0);
  const [openGateModal, setOpenSelectModal] = useState(false);
  const [isEmpSignedin, setIsEmpSignedin] = useState(
    getLocalStorage("EmpData")
  );

  useEffect(() => {
    if (Object.keys(useDelivery.selectedDeliveryOption).length > 0) {
      if (
        useDelivery.selectedDeliveryOption.deliveryOption === "collect at gate"
      ) {
        setDelOpt(1);
      } else {
        setDelOpt(0);
      }
    }
  });

  const handleModalOpen = () => {
    setOpenSelectModal(true);
  };

  const handleModalClose = () => {
    setOpenSelectModal(false);
  };

  const onTakeawayClick = () => {
    let selectedDeliveryOption = {
      deliveryOption: config.deliveryOptions.takeaway,
      deliveryAddress: "",
      deliveryTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      isPackagingRequested: true,
    };
    useDelivery.handleDeliverySelection(selectedDeliveryOption);
    useCart.updateDeliveryOptions(selectedDeliveryOption);
    setDelOpt(0);
  };

  const onDeliveryClick = () => {
    setDelOpt(1);
    handleModalOpen();
  };

  const handleBackHome = () => {
    history.push({ pathname: "/homepage" });
  };

  const handleStartOver = () => {
    useUser.onLogout();
    useCart.reset();
    useDelivery.resetDeliverySelection();
    useFoodType.resetFoodType();
    history.push({ pathname: "/" });
  };

  const handleSettings = () => {
    history.push({ pathname: "/empSignIn" });
  };

  const handleEmpSignout = () => {
    setIsEmpSignedin(false);
    removeLocalStorage("EmpData");
  };

  return (
    <HeaderWrapper
      style={{
        justifyContent: props.hideLogoAndGoBack ? "flex-end" : "space-between",
      }}
    >
      {props.hideLogoAndGoBack ? null : props.isHomepage ? (
        <LogoWrapper>
          <Image src={FSTRLogo} />
        </LogoWrapper>
      ) : (
        <GoBackWrapper onClick={handleBackHome}>
          <BackArrowWrapper>
            <Image src={ArrowLeft} style={{ height: "100%", width: "100%" }} />
          </BackArrowWrapper>
          <BackHomeLabel>
            <Text>Back Home</Text>
          </BackHomeLabel>
        </GoBackWrapper>
      )}
      {hideDelSelectionPostStart === "true" && !props.hideDeliveryAndLogo ? (
        <SelectedDeliveryOptionText>
          <Text>
            {useDelivery.selectedDeliveryOption?.deliveryOption ===
            config.deliveryOptions.deliveryAtGate
              ? "Delivery"
              : "Takeaway"}
          </Text>
        </SelectedDeliveryOptionText>
      ) : props.hideDeliveryAndLogo ? null : props.hideDeliverySelection ? (
        <LogoWrapper>
          <Image src={FSTRLogo} />
        </LogoWrapper>
      ) : showDeliveryOption() ? (
        <ToggleButtonWrapper>
          <ToggleButtonContainer>
            <Button
              className={
                delOpt === 0
                  ? styles.toggle_btn_active
                  : styles.toggle_btn_inactive
              }
              onClick={() => onTakeawayClick()}
            >
              <ToggleButtonLabelText>
                <Text color={delOpt === 0 ? "#222222" : "#ffffff"}>
                  Takeaway
                </Text>
              </ToggleButtonLabelText>
            </Button>
            <Button
              className={
                delOpt === 1
                  ? styles.toggle_btn_active
                  : styles.toggle_btn_inactive
              }
              onClick={() => onDeliveryClick()}
            >
              <ToggleButtonLabelText>
                <Text color={delOpt === 1 ? "#222222" : "#ffffff"}>
                  Delivery
                </Text>
              </ToggleButtonLabelText>
            </Button>
          </ToggleButtonContainer>
        </ToggleButtonWrapper>
      ) : (
        <SelectedDeliveryOptionText>
          <Text>Takeaway</Text>
        </SelectedDeliveryOptionText>
      )}
      <StartOverContainer>
        {props.hideStartOver ? null : (
          <Button
            onClick={handleStartOver}
            style={{
              backgroundColor: "transparent",
              border: "none",
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <StartOverIconWrapper>
              <Image
                src={StartOver}
                style={{ width: "100%", height: "100%" }}
              />
            </StartOverIconWrapper>
            <StartOverLabelText>
              <Text>Start Over</Text>
            </StartOverLabelText>
          </Button>
        )}
        {isEmpSignedin ? (
          <Image
            src={Signout}
            style={{ width: "48px", height: "48px" }}
            onClick={handleEmpSignout}
          />
        ) : (
          <Image
            src={Setting}
            style={{ width: "48px", height: "48px" }}
            onClick={handleSettings}
          />
        )}
      </StartOverContainer>
      <GateSelectionModal
        open={openGateModal}
        handleClose={handleModalClose}
        handleSubmit={handleModalClose}
      />
    </HeaderWrapper>
  );
}

export default Header;
